import { render, staticRenderFns } from "./PeopleCard.vue?vue&type=template&id=e743e814&scoped=true&"
import script from "./PeopleCard.vue?vue&type=script&lang=js&"
export * from "./PeopleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e743e814",
  null
  
)

export default component.exports